module.exports = __webpack_public_path__ + "img/DGB-alt.161305ac.svg";